<template>
  <div class="bg-white p-4 sm:p-6 rounded-xl shadow">
    <div class="flex items-center justify-between mb-4">
      <h3 class="font-bold text-gray-700">สินค้าขายดี (30 วันล่าสุด)</h3>
      <router-link to="/admin/reports" class="text-primary hover:text-primary-dark text-sm">
        ดูทั้งหมด →
      </router-link>
    </div>
    
    <div v-if="bestSellers && bestSellers.length > 0" class="space-y-3">
      <div v-for="(product, index) in bestSellers" :key="index" class="flex items-center gap-3 p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
        <!-- Rank -->
        <div class="shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold"
             :class="getRankClass(index)">
          {{ index + 1 }}
        </div>
        
        <!-- Product Info -->
        <div class="shrink-0">
          <p class="font-medium text-gray-900 truncate">{{ product.product_name }}</p>
          <p class="text-sm text-gray-500">ขายไป {{ formatNumber(product.total_quantity) }} ชิ้น</p>
        </div>
        
        <!-- Trend Icon -->
        <div class="shrink-0">
          <svg class="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
          </svg>
        </div>
      </div>
    </div>
    
    <div v-else class="text-center py-8 text-gray-500">
      <svg class="w-12 h-12 mx-auto mb-3 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
      </svg>
      <p>ยังไม่มีข้อมูลสินค้าขายดี</p>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  bestSellers: {
    type: Array,
    default: () => []
  }
});

const formatNumber = (num) => {
  return new Intl.NumberFormat('th-TH').format(num);
};

const getRankClass = (index) => {
  if (index === 0) return 'bg-yellow-500 text-white'; // Gold
  if (index === 1) return 'bg-gray-400 text-white';   // Silver
  if (index === 2) return 'bg-orange-600 text-white'; // Bronze
  return 'bg-gray-200 text-gray-700';
};
</script>
